export {
  I18N_LOADING_WORKSPACES_FAILED,
  WORKSPACE_STATES,
  WORKSPACE_DESIRED_STATES,
  WORKSPACES_LIST_PAGE_SIZE as WORKSPACES_DROPDOWN_GROUP_PAGE_SIZE,
  WORKSPACES_LIST_POLL_INTERVAL as WORKSPACES_DROPDOWN_GROUP_POLL_INTERVAL,
  CLICK_NEW_WORKSPACE_BUTTON_EVENT_NAME,
} from '../common/constants';
